import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const ditArchitectureComponent: ComponentDef = {
  id: 'dit-architecture',
  name: 'DiT Architecture',
  description: 'Diffusion Transformer predicts noise from latent patches and timestep embeddings.',
  category: 'multimodal',
  params: [
    { name: 'n_patches', label: 'Latent patches', type: 'number', default: 256, min: 1, max: 1024, step: 1 },
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 768, min: 64, max: 4096, step: 64 }
  ],
  buildGraph: (params) => {
    const n_patches = Number(params.n_patches);
    const d_model = Number(params.d_model);

    const g = new GraphBuilder();
    g.input('latent', [n_patches, d_model]);
    g.input('timestep', [d_model]);

    g.linear('patch_embed', 'latent', [d_model, d_model]);
    g.add('cond', 'patch_embed', 'timestep');
    g.norm('norm', 'cond', 'AdaLN');
    g.linear('transformer', 'norm', [d_model, d_model]);
    g.linear('noise', 'transformer', [d_model, d_model]);
    g.output('out', 'noise');
    return g.build();
  }
};
